import React, { useState } from 'react';
import { CirclePicker } from 'react-color';
// Removed Col, Row imports
import { CBCheckItem } from '../../core/components/cbd';

const ColorPicker = ({ type, color="default", onColorChangeCallback, preview=false, radius=50 }) => {
    
    const [pickedColor, setPickedColor] = useState("#fff")
    const msColors = ["#ffff00",
    "#ff0000",
    "#800080",
    "#ffa500",
    "#008000",
    "#0000ff"]
    const msMapping = ["Yellow category",
    "Red category",
    "Purple category",
    "Orange category",
    "Green category",
    "Blue category"]
   
    const googleColors = [
        "#a4bdfc",
        "#7ae7bf",
        "#dbadff",
        "#ff887c",
        "#fbd75b",
        "#ffb878",
        "#46d6db",
        "#e1e1e1",
        "#5484ed",
        "#51b749",
        '#d50000', // 11 Tomato
    ]
    const calendarType = type
    // console.log("CALENDAR TYPE")
    // console.log(calendarType)
    function colorChange(color,event) {
        
        //console.log(color)
        // if(color == "default") {
        //     setPickedColor("#fff")
        //     onColorChangeCallback("default")
        // } else {
        setPickedColor(color.hex)

        if(calendarType == "ms" || calendarType == "ews"){
            
            onColorChangeCallback(msMapping[msColors.indexOf(color.hex) != -1 ? msColors.indexOf(color.hex)  : 0])
        } else {
            onColorChangeCallback(`${(googleColors.indexOf(color.hex)+1)}`) 
        }
    // }
        
    }
    
const colors = !preview ? ((calendarType == "ms"||calendarType == "ews") ? msColors : googleColors) :
                            ((calendarType == "ms"||calendarType == "ews") ? [msMapping.indexOf(color) != -1 ? msColors[msMapping.indexOf(color)] : '#fff'] : [googleColors[parseInt(color)-1]])
if( color != 'default' && !preview && pickedColor=='#fff') {
    
    var colorPicked = '#fff'
    if (calendarType == "ms"||calendarType == "ews") {
        var idx = msMapping.indexOf(color)
        if(idx == -1){
            colorPicked = 'default'
        } else {
         colorPicked = msColors[idx]
        } 
         
    } else {
        colorPicked = googleColors[color-1]
    }
    
    setPickedColor(colorPicked)
} else {
    if(color == 'default' && pickedColor == '#fff') {
         setPickedColor('default')
    } else {
        //setPickedColor(color)
    }
}
    


      return <>
          {!preview && (
              // Replaced Row/Col with simple div wrapper
              <div>
                <div className="mb-2"> {/* Added margin below picker */}
                  <CirclePicker color={pickedColor} radius={radius} colors={colors} onChangeComplete={colorChange} />
                  {/* Commented out button remains */}
                </div>
                <div> {/* Wrapper for CheckItem */}
                  <CBCheckItem
                    className="ml-1.5 mt-2" // Replaced style with Tailwind
                    onChange={(checked) => {
                      if(checked) {
                        setPickedColor('default')
                        onColorChangeCallback('default')
                      }
                    }}
                    checked={pickedColor == 'default'}
                    label="Calendar Default"
                    color="#B85614" // Keep color prop if CBCheckItem supports it
                  />
                </div>
              </div>
            )}
            {preview && (
            <center style={{marginTop:5, marginRight:20}}><CirclePicker width="5px" circleSize={20} colors={colors} /></center>
            )}
          </>;
    
  }

export default ColorPicker
